module.exports = __webpack_public_path__ + "img/svg/explain-1.5b2461c539d556a8d32d876113b79217.svg";